import * as Bowser from 'bowser';
import logger from './logger';
import { PLATFORM_WHITELIST } from './constants';

export type Platform = 'tablet' | 'mobile' | 'desktop' | 'tv' | undefined;

export interface EnvironmentContext {
    browserName: string | undefined;
    browserVersion: string | undefined;
    osName: string | undefined;
    osVersion: string | undefined;
    platform: Platform;
};

export const get = (userAgent: string): EnvironmentContext => {
    const {
        browser: {
            name: browserName,
            version: browserVersion,
        },
        os: {
            name: osName,
            version: osVersion,
        },
        platform: {
            type: platformType,
        },
    } = Bowser.getParser(userAgent).getResult();

    let platform: Platform;
    if (PLATFORM_WHITELIST.includes(platformType)) {
        // There must be a better way of re-typing to `Platform`, but I haven't found it:
        platform = platformType as Platform;
    } else {
        logger.error(new Error(`Unknown device platform detected.  Expecting ${PLATFORM_WHITELIST.join(' | ')}. Received instead ${platformType}. This was parse from the user agent: ${userAgent}.`));
    }

    return {
        browserName,
        browserVersion,
        osName,
        osVersion,
        platform,
    }
};
